import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../../charts/Chart';
import { barStackChartConfiguration } from './utilities/helpers';

const BarStackChart = ({ onChartCallback, series, xAxis, yAxis, ...props }) => {
  return (
    <Chart
      onChartCallback={onChartCallback}
      options={merge({}, barStackChartConfiguration, {
        series,
        type: 'bar',
        xAxis,
        yAxis,
        ...props,
      })}
      {...props}
    />
  );
};

BarStackChart.propTypes = {
  onChartCallback: PropTypes.func,
  series: PropTypes.array,
  xAxis: PropTypes.object,
  yAxis: PropTypes.object,
};

export default BarStackChart;
